<template>
  <div class="pref">
    <InputCheckBox
      v-model="state[preference.name]"
      :name="preference.name"
      :label="preference.title"
    />
    <p v-cleaned="preference.descriptionHTML"></p>
  </div>
</template>
<script setup lang="ts">
interface Props {
  preference: any;
}
defineProps({
  preference: null
});

const { state } = inject(INJECT_SETTINGS_PREFERENCES);
</script>
<style lang="scss" scoped>
.pref {
  display: flex;
  gap: var(--gap_xxs);
  flex-direction: column;
}
p {
  @include font('s', 400);

  color: var(--color_neutral_700);
  :deep(a) {
    color: var(--color_secondary);
    text-decoration: underline;
  }
}
</style>
